import React, { useState, useEffect } from "react";
import { useNavigate, useMatch } from "react-router-dom";
import { Helmet } from "react-helmet";
import styles from "./Landing.module.css";
import moment from "moment";
import displayRazorpay from "./razorpay/Razorpay";
import axios from "axios";
import { useDispatch } from "react-redux";

const products = [
  {
    _id: "1",
    name: "Phonepe",
  },
  {
    _id: "2",
    name: "Razorpay",
  },
  {
    _id: "3",
    name: "Stripe",
  },
];

const CheckOutPlatformPage = ({
  paymentData,
  singleEvent,
  submit,
  setSubmit,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [gateways, setGateways] = useState([...products]);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!paymentData) {
      setSubmit(false);
    }
  }, []);

  useEffect(() => {
    if (singleEvent && submit) {
      let arr = Object.keys(singleEvent?.paymentGateway).map((key, id) => {
        return {
          name: key,
          value: singleEvent?.paymentGateway[key],
        };
      });
      console.log("arr", arr);
      setGateways(arr);
    }
  }, [singleEvent, submit]);

  const handleSubmit = (id) => {
    if (id === "1") {
      setLoading(true);
      axios({
        method: "POST",
        url: `${process.env.REACT_APP_SERVER_URL}/payment/phonepe`,
        data: {
          ...paymentData,
        },
      })
        .then((response) => {
          setLoading(false);
          localStorage.removeItem("tempUserPayDetails");
          window.location.href =
            response.data.data.instrumentResponse.redirectInfo.url;
        })
        .catch((error) => {});
    } else if (id === "2") {
      displayRazorpay({
        ...paymentData,
        userData: [
          paymentData.userData,
          {
            ...paymentData.userData,
            email: "surve4404@gmail.com",
          },
        ],

        billing: {
          address: "Mumbai",
          email: "testinguser4404@gmail.com",
          name: "YO",
          phone: "1234567890",
        },
        navigate: navigate,
        setLoading: setLoading,
        dispatch: dispatch,
      });
    } else if (id === "3") {
      setLoading(true);
      axios({
        method: "POST",
        url: `${process.env.REACT_APP_SERVER_URL}/payment/stripe/init`,
        data: {
          ...paymentData,
        },
      })
        .then((response) => {
          setLoading(false);
          localStorage.removeItem("tempUserPayDetails");
          window.location.href = response.data.url;
        })
        .catch((error) => {});
    }
  };
  return (
    <>
      {loading && (
        <div className="fixed left-[0px] w-full h-full bg-[#dcdcdc1d]">
          <div className="text-center h-[100%] w-[100%]">
            <div className="h-[100vh] w-full grid place-items-center">
              <svg
                className="inline mr-2 w-11 h-11 text-gray-200 animate-spin dark:text-gray-600 fill-primary"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      )}
      {!loading && (
        <>
          <div className={styles.nav_parent}>
            <nav className={styles.navbar}>
              <div className={styles.logo}>
                <img src="/svgs/logo.svg" alt="logo" /> Warpbay
              </div>
              <ul className={styles.menu_ul}>
                <li className={styles.nav_home}>
                  <p
                    onClick={() =>
                      window.open(`${window.location.origin}/login`, "_blank")
                    }
                  >
                    Login
                  </p>
                </li>
              </ul>
            </nav>
          </div>

          <div className="mx-auto w-[824px] max-w-[1440px]">
            <div className="grid grid-cols-3 mt-0 mx-auto w-full mb-[100px]">
              {/* Shopping Cart */}
              <div className="col-span-2 mr-[40px]">
                <div className="flex gap-2 items-center mb-4">
                  <div
                    className="cursor-pointer"
                    onClick={() => setSubmit(false)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-6 h-6 cursor-pointer"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
                      />
                    </svg>
                  </div>

                  <h2 className="text-[20px] font-[600]">Payment Options</h2>
                </div>
                <ul>
                  {/* {gateways.length > 0
                    ? gateways.map((ele, id) => (
                        <li
                          key={id}
                          className="grid grid-cols-[1fr_75px] items-center mb-[10px] border-b py-3 px-4"
                        >
                          <p className="text-[15px] font-[600]">
                            <i className="fa-solid fa-ticket text-gray-400"></i>{" "}
                            {ele.name}{" "}
                          </p>
                          <button
                            className="px-2 py-1 bg-primary text-white rounded text-[13px] w-full"
                            onClick={() => handleSubmit(product._id)}
                          >
                            select
                          </button>
                        </li>
                      ))
                    : null} */}
                  <li
                    key="asd"
                    className="grid grid-cols-[1fr_75px] items-center mb-[10px] border-b py-3 px-4"
                  >
                    <p className="text-[15px] font-[600]">
                      <i className="fa-solid fa-ticket text-gray-400"></i>{" "}
                      PhonePe
                    </p>
                    <button
                      className="px-2 py-1 bg-primary text-white rounded text-[13px] w-full"
                      onClick={() => handleSubmit("1")}
                    >
                      select
                    </button>
                  </li>
                  <li
                    key="asd"
                    className="grid grid-cols-[1fr_75px] items-center mb-[10px] border-b py-3 px-4"
                  >
                    <p className="text-[15px] font-[600]">
                      <i className="fa-solid fa-ticket text-gray-400"></i>{" "}
                      Razorpay
                    </p>
                    <button
                      className="px-2 py-1 bg-gray-600 text-white rounded text-[13px] w-full"
                      // onClick={() => handleSubmit("2")}
                    >
                      select
                    </button>
                  </li>
                  <li
                    key="asd"
                    className="grid grid-cols-[1fr_75px] items-center mb-[10px] border-b py-3 px-4"
                  >
                    <p className="text-[15px] font-[600]">
                      <i className="fa-solid fa-ticket text-gray-400"></i>{" "}
                      Stripe
                    </p>
                    <button
                      className="px-2 py-1 bg-gray-600 text-white rounded text-[13px] w-full"
                      // onClick={() => handleSubmit("3")}
                    >
                      select
                    </button>
                  </li>
                </ul>
              </div>

              {/* Sidebar for Cart Preview */}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default CheckOutPlatformPage;
